<template>
  <span>
    {{ formatedDescription }}
    <router-link v-if="descriptionToLong" :to="to" class="text-primary">{{
      $t('item.readOn')
    }}</router-link>
  </span>
</template>

<script>
export default {
  props: {
    description: {
      required: false,
      default: '',
      type: String
    },
    to: {
      required: true,
      default: function() {
        return {}
      },
      type: Object
    }
  },
  computed: {
    descriptionToLong: function() {
      if (this.description === null) return false
      if (this.description === '') return false
      if (this.description.length < 270) return false

      return true
    },
    formatedDescription: function() {
      let description = this.description
      if (description === null) return ''
      if (description === '') return ''

      description = description
        .replaceAll('<br>', '')
        .replaceAll('<br />\n', '')
        .replaceAll('<br />\n', '')
        .replaceAll('<p>', '')
        .replaceAll('</p>', '')

      // To long
      if (this.descriptionToLong) return `${description.substring(0, 270)}...`

      return description
    }
  }
}
</script>

<style></style>
